/*
 * Dedikerad bokningslogik för specialresan Visby (VBY) ↔ Tallinn (TLL).
 * Fast tur-och-retur, endast vuxna. Skapar bokning via live2-API:t och
 * lägger flygbiljett-varianten 57876086423883 (VT-Enkel-Vuxen) i varukorgen –
 * ett line item per ben (utresa + retur).
 */
(function(){
  // ---- Fast reseinformation (hårdkodad specialresa) ----
  var VARIANT_ID = 57876086423883;

  var OUTBOUND = {
    flightNumber: '751',
    departureDateTime: '2026-07-24T10:15:00',
    arrivalDateTime: '2026-07-24T12:45:00',
    origin: 'VBY',
    destination: 'TLL',
    bookingClass: 'W',
    fareBasis: 'WEB',
    marketingAirline: 'OJ'
  };
  var RETURN = {
    flightNumber: '752',
    departureDateTime: '2026-07-26T18:50:00',
    arrivalDateTime: '2026-07-26T19:20:00',
    origin: 'TLL',
    destination: 'VBY',
    bookingClass: 'W',
    fareBasis: 'WEB',
    marketingAirline: 'OJ'
  };

  var API_BASE = 'https://bmaflyg.live2.se';
  var TOKEN_SECRET = 'tvsoffataklampaknapputtag2847613kjslfm';

  // Fast pris för hela tur- och returresan (i ören): 2 495 kr per person.
  var FIXED_PRICE_CENTS = 249500;

  function boot(){
    var root = document.getElementById('tallinn-booking');
    if (!root) return;
    if (root.__tlBound) return;
    root.__tlBound = true;

    var adultsInput = root.querySelector('#tl-adults');
    var adultsMinusBtn = root.querySelector('#tl-adults-minus');
    var adultsPlusBtn  = root.querySelector('#tl-adults-plus');
    var list        = root.querySelector('#tl-passenger-list');
    var totalCountEl = root.querySelector('#tl-total-count');
    var totalPriceEl = root.querySelector('#tl-total-price');
    var tripMiniEl   = root.querySelector('#tl-trip-mini');
    var addBtn       = root.querySelector('#tl-add-to-cart');
    var errEl        = root.querySelector('#tl-error');
    var supportBtn   = root.querySelector('#tl-support-btn');

    var currency = (root.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK').toUpperCase();
    var locale = document.documentElement.lang || 'sv-SE';

    // Fast pris (i ören) per person för hela tur- och returresan (2 495 kr).
    var unitPriceCents = FIXED_PRICE_CENTS;

    // ---- Landskoder för telefon ----
    var COUNTRY_CODES = [
      { code:'46', name:'Sverige' },
      { code:'47', name:'Norge' },
      { code:'45', name:'Danmark' },
      { code:'358', name:'Finland' },
      { code:'372', name:'Estland' },
      { code:'371', name:'Lettland' },
      { code:'370', name:'Litauen' },
      { code:'49', name:'Tyskland' },
      { code:'44', name:'Storbritannien' },
      { code:'1', name:'USA/Kanada' }
    ];
    var COUNTRY_CODE_DATALIST_ID = 'tl-country-codes-list';

    function ensureCountryCodeDatalist(){
      var dl = document.getElementById(COUNTRY_CODE_DATALIST_ID);
      if (dl) return dl;
      dl = document.createElement('datalist');
      dl.id = COUNTRY_CODE_DATALIST_ID;
      COUNTRY_CODES.forEach(function(c){
        var o = document.createElement('option');
        o.value = '+' + c.code;
        o.label = c.name + ' (+' + c.code + ')';
        dl.appendChild(o);
      });
      document.body.appendChild(dl);
      return dl;
    }

    // ---- Hjälpfunktioner ----
    function clampNum(v, min, max){ var n = Math.max(min, Math.min(max, parseInt(v||0,10))); return isFinite(n) ? n : 0; }
    function digitsOnly(s){ return String(s||'').replace(/\D+/g,''); }
    function formatMoney(cents){
      try {
        return new Intl.NumberFormat(locale, { style:'currency', currency:currency }).format((cents||0)/100);
      } catch(e){
        return ((cents||0)/100).toFixed(2) + ' ' + currency;
      }
    }
    function sanitizeSwedishNameChars(s){
      return String(s||'')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[ÅÄåä]/g, 'A')
        .replace(/[Öö]/g, 'O');
    }
    function titleByGender(g){ return g === 'Kvinna' ? 'Ms.' : 'Mr.'; }
    function splitPhone(raw, preferredCountryCode){
      var preferred = String(preferredCountryCode||'').replace(/\D+/g,'');
      var local = String(raw||'').replace(/\D+/g,'');
      if (preferred){
        if (preferred === '46') local = local.replace(/^0+/, '');
        return { countryCode: preferred, number: local };
      }
      var s = (raw||'').replace(/[^\d+]/g,'');
      if (!s) return { countryCode:'46', number:'' };
      if (s[0] === '+'){
        var m = s.slice(1).match(/^(\d{1,3})(\d+)$/);
        if (m) return { countryCode:m[1], number:m[2] };
      }
      if (s.indexOf('00') === 0){
        var m2 = s.slice(2).match(/^(\d{1,3})(\d+)$/);
        if (m2) return { countryCode:m2[1], number:m2[2] };
      }
      return { countryCode:'46', number:s.replace(/^0+/, '') };
    }

    function showError(msg){
      if (!errEl) return;
      errEl.style.display = msg ? 'block' : 'none';
      errEl.textContent = msg || '';
    }
    function showErrorHtml(html){
      if (!errEl) return;
      errEl.style.display = html ? 'block' : 'none';
      errEl.innerHTML = html || '';
    }
    function showSupportBtn(show){ if (supportBtn) supportBtn.style.display = show ? 'inline-block' : 'none'; }

    // ---- UI-byggare ----
    function field(cfg){
      var w = document.createElement('label');
      w.className = 'pf-field';
      var s = document.createElement('span');
      s.textContent = cfg.label + (cfg.required ? ' *' : '');
      w.appendChild(s);
      var i = document.createElement('input');
      i.type = cfg.type || 'text';
      i.required = !!cfg.required;
      i.setAttribute('data-name', cfg.name);
      i.name = 'passenger_' + cfg.name;
      i.autocomplete = cfg.autocomplete || 'off';
      w.appendChild(i);
      return w;
    }
    function select(cfg){
      var w = document.createElement('label');
      w.className = 'pf-field';
      var s = document.createElement('span');
      s.textContent = cfg.label + (cfg.required ? ' *' : '');
      w.appendChild(s);
      var sel = document.createElement('select');
      sel.required = !!cfg.required;
      sel.setAttribute('data-name', cfg.name);
      sel.name = 'passenger_' + cfg.name;
      if (cfg.placeholder){
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = cfg.placeholder;
        ph.disabled = true;
        ph.selected = true;
        sel.appendChild(ph);
      }
      cfg.options.forEach(function(opt){
        var o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.text;
        sel.appendChild(o);
      });
      w.appendChild(sel);
      return w;
    }
    function phoneField(cfg){
      ensureCountryCodeDatalist();
      var w = document.createElement('label');
      w.className = 'pf-field pf-phone-field';
      var s = document.createElement('span');
      s.textContent = cfg.label + (cfg.required ? ' *' : '');
      w.appendChild(s);

      var row = document.createElement('div');
      row.className = 'pf-phone-row';
      row.style.display = 'flex';
      row.style.gap = '8px';
      row.style.alignItems = 'center';

      var countryVisible = document.createElement('input');
      countryVisible.type = 'text';
      countryVisible.className = 'pf-country-code-visible';
      countryVisible.setAttribute('list', COUNTRY_CODE_DATALIST_ID);
      countryVisible.value = '+46';
      countryVisible.autocomplete = 'off';
      countryVisible.setAttribute('aria-label', 'Landskod');
      countryVisible.style.maxWidth = '96px';
      countryVisible.style.flex = '0 0 96px';
      countryVisible.style.textAlign = 'center';

      var countryHidden = document.createElement('input');
      countryHidden.type = 'hidden';
      countryHidden.setAttribute('data-name', 'phoneCountryCode');
      countryHidden.name = 'passenger_phoneCountryCode';
      countryHidden.value = '46';

      var phone = document.createElement('input');
      phone.type = 'tel';
      phone.required = !!cfg.required;
      phone.setAttribute('data-name', 'phone');
      phone.name = 'passenger_phone';
      phone.autocomplete = 'tel-national';
      phone.inputMode = 'tel';
      phone.style.flex = '1 1 auto';

      countryVisible.addEventListener('input', function(){
        countryHidden.value = digitsOnly(countryVisible.value) || '46';
      });

      row.appendChild(countryVisible);
      row.appendChild(countryHidden);
      row.appendChild(phone);
      w.appendChild(row);
      return w;
    }

    function buildPassenger(num, includeContact){
      var wrapper = document.createElement('div');
      wrapper.className = 'pf-passenger';
      wrapper.dataset.pfType = 'Vuxen';
      var title = document.createElement('h3');
      title.textContent = 'Vuxen #' + num;
      wrapper.appendChild(title);

      var line = document.createElement('div');
      line.className = 'pf-line';
      line.appendChild(field({ label:'Förnamn', name:'firstName', required:true, autocomplete:'given-name' }));
      line.appendChild(field({ label:'Efternamn', name:'lastName', required:true, autocomplete:'family-name' }));
      line.appendChild(select({ label:'Kön', name:'gender', required:true, placeholder:'Välj...', options:[
        { value:'Man', text:'Man' }, { value:'Kvinna', text:'Kvinna' }, { value:'Annat', text:'Annat' }
      ]}));
      wrapper.appendChild(line);

      if (includeContact){
        var contact = document.createElement('div');
        contact.className = 'pf-line-contact';
        contact.appendChild(phoneField({ label:'Telefon', name:'phone', required:true, type:'tel' }));
        contact.appendChild(field({ label:'E-post', name:'email', required:true, type:'email', autocomplete:'email' }));
        wrapper.appendChild(contact);
      }
      return wrapper;
    }

    function renderTripMini(){
      if (!tripMiniEl) return;
      tripMiniEl.innerHTML =
        '<div class="pf-trip-leg"><strong>Utresa</strong> 24 juli 2026 · OJ751 · Visby (VBY) 10:15 → Tallinn (TLL) 12:45</div>' +
        '<div class="pf-trip-leg"><strong>Retur</strong> 26 juli 2026 · OJ752 · Tallinn (TLL) 18:50 → Visby (VBY) 19:20</div>';
      tripMiniEl.style.display = 'flex';
    }

    function render(){
      var n = clampNum(adultsInput.value, 1, 9);
      if (String(n) !== adultsInput.value) adultsInput.value = String(n);
      list.innerHTML = '';
      for (var i = 1; i <= n; i++){
        list.appendChild(buildPassenger(i, i === 1));
      }
      prefillCustomer();
      updateStepperState();
      updateTotal();
    }

    function updateStepperState(){
      var n = clampNum(adultsInput.value, 1, 9);
      if (adultsMinusBtn) adultsMinusBtn.disabled = (n <= 1);
      if (adultsPlusBtn)  adultsPlusBtn.disabled = (n >= 9);
    }

    function stepAdults(delta){
      var n = clampNum(adultsInput.value, 1, 9);
      n = Math.max(1, Math.min(9, n + delta));
      adultsInput.value = String(n);
      render();
    }

    function prefillCustomer(){
      var first = root.dataset.customerFirst;
      var last  = root.dataset.customerLast;
      var email = root.dataset.customerEmail;
      var phone = root.dataset.customerPhone;
      if (!first && !last && !email && !phone) return;
      var card = list.querySelector('.pf-passenger');
      if (!card) return;
      function setIfEmpty(sel, val){ var el = card.querySelector(sel); if (el && !el.value && val) el.value = val; }
      setIfEmpty('[data-name="firstName"]', first);
      setIfEmpty('[data-name="lastName"]', last);
      setIfEmpty('[data-name="email"]', email);
      if (phone){
        var p = splitPhone(phone, '46');
        var phoneEl = card.querySelector('[data-name="phone"]');
        if (phoneEl && !phoneEl.value) phoneEl.value = p.number;
      }
    }

    function collect(){
      var items = [];
      list.querySelectorAll('.pf-passenger').forEach(function(card, idx){
        var obj = { type: card.dataset.pfType, index: idx + 1 };
        card.querySelectorAll('[data-name]').forEach(function(input){
          var key = input.getAttribute('data-name');
          var val = (input.value || '').trim();
          if (key === 'phoneCountryCode') val = digitsOnly(val) || '46';
          if (key === 'phone') val = digitsOnly(val);
          obj[key] = val;
        });
        if (obj.phone && obj.phoneCountryCode === '46') obj.phone = obj.phone.replace(/^0+/, '');
        obj.firstName = sanitizeSwedishNameChars(obj.firstName);
        obj.lastName  = sanitizeSwedishNameChars(obj.lastName);
        items.push(obj);
      });
      return items;
    }

    function isComplete(){
      var n = clampNum(adultsInput.value, 1, 9);
      if (n < 1) return false;
      var ok = true;
      list.querySelectorAll('.pf-passenger').forEach(function(card){
        card.querySelectorAll('input[required], select[required]').forEach(function(el){
          if (!String(el.value || '').trim()) ok = false;
        });
      });
      return ok;
    }

    function updateTotal(){
      var n = clampNum(adultsInput.value, 1, 9);
      if (totalCountEl) totalCountEl.textContent = String(n);
      // 2 495 kr per person för hela tur- och returresan
      var totalCents = n * unitPriceCents;
      if (totalPriceEl) totalPriceEl.textContent = unitPriceCents ? formatMoney(totalCents) : '—';
      if (addBtn) addBtn.disabled = !isComplete();
    }

    // ---- Boknings-API ----
    function utcDateYYYYMMDD(){ return new Date().toISOString().slice(0,10); }
    function utcDateYesterday(){ var d = new Date(); d.setUTCDate(d.getUTCDate()-1); return d.toISOString().slice(0,10); }
    async function sha256Hex(str){
      var enc = new TextEncoder();
      var data = enc.encode(str);
      var hash = await (window.crypto && crypto.subtle ? crypto.subtle.digest('SHA-256', data) : Promise.reject(new Error('Web Crypto not available')));
      return Array.from(new Uint8Array(hash)).map(function(b){ return b.toString(16).padStart(2,'0'); }).join('');
    }
    function buildAuthTokenForDateStr(dateStr){ return sha256Hex(String(dateStr) + '+' + TOKEN_SECRET); }

    function buildPassengersForApi(collected){
      var result = [];
      var adults = collected.filter(function(p){ return p.type === 'Vuxen'; });
      var ctcSource = adults.length ? adults[0] : null;
      if (ctcSource){
        var ph = splitPhone(ctcSource.phone || '', ctcSource.phoneCountryCode || '');
        result.push({
          type:'CTC',
          title: titleByGender(ctcSource.gender),
          firstName: sanitizeSwedishNameChars(ctcSource.firstName || 'Unknown'),
          lastName: sanitizeSwedishNameChars(ctcSource.lastName || 'Unknown'),
          phone: { countryCode: ph.countryCode, number: ph.number },
          email: ctcSource.email || ''
        });
      }
      adults.forEach(function(a){
        var ph = a.phone ? splitPhone(a.phone, a.phoneCountryCode || '') : null;
        result.push({
          type:'ADT',
          title: titleByGender(a.gender),
          firstName: sanitizeSwedishNameChars(a.firstName || 'Unknown'),
          lastName: sanitizeSwedishNameChars(a.lastName || 'Unknown'),
          phone: ph ? { countryCode: ph.countryCode, number: ph.number } : undefined,
          email: a.email || undefined
        });
      });
      return result;
    }

    async function createBooking(collected){
      var passengers = buildPassengersForApi(collected);
      var ctc = passengers.find(function(p){ return p.type === 'CTC'; });
      var payload = {
        itinerary: { segments: [OUTBOUND, RETURN] },
        passengers: passengers,
        contact: ctc ? { email: ctc.email || '', phone: ctc.phone || { countryCode:'46', number:'' } } : { email:'', phone:{ countryCode:'46', number:'' } },
        currency: currency || 'SEK'
      };
      var token = await buildAuthTokenForDateStr(utcDateYYYYMMDD());
      var url = API_BASE.replace(/\/+$/,'') + '/booking';
      var r = await fetch(url, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Auth-Token': token },
        body: JSON.stringify(payload),
        credentials:'omit',
        mode:'cors'
      });
      if (r.status === 401){
        var token2 = await buildAuthTokenForDateStr(utcDateYesterday());
        r = await fetch(url, {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Auth-Token': token2 },
          body: JSON.stringify(payload),
          credentials:'omit',
          mode:'cors'
        });
      }
      if (!r.ok){
        var t = await r.text().catch(function(){ return ''; });
        throw new Error(t || ('Bokning misslyckades (HTTP ' + r.status + ').'));
      }
      var data = await r.json().catch(function(){ return null; });
      var norm = (data && data.normalized) ? data.normalized : data;
      var bookingRef = (data && data.bookingReference) ? data.bookingReference : (norm && norm.bookingReference);
      if (bookingRef && (String(bookingRef).length > 10 || String(bookingRef).indexOf(' ') !== -1 || String(bookingRef).indexOf('>') !== -1)){
        bookingRef = null;
      }
      var ok = (norm && norm._meta && norm._meta.hasReservation);
      if (bookingRef && ok === undefined) ok = true;
      if (!bookingRef || ok === false){
        throw new Error('Ingen giltig bokningsreferens returnerades från bokningssystemet.');
      }
      return bookingRef;
    }

    function buildBaseProps(items, bookingRef){
      return {
        'Adults': String(items.length),
        'Children': '0',
        'Infants': '0',
        'Passengers': JSON.stringify(items),
        'Trip Type': 'Round-trip',
        'Origin': 'VBY',
        'Outbound Direction': 'Visby → Tallinn',
        'Outbound Date': '2026-07-24',
        'Outbound Time': '10:15',
        'Outbound Flight Number': '751',
        'Return Direction': 'Tallinn → Visby',
        'Return Date': '2026-07-26',
        'Return Time': '18:50',
        'Return Flight Number': '752',
        'Booking Reference': bookingRef
      };
    }

    async function addToCart(){
      showError('');
      showSupportBtn(false);
      if (!isComplete()){
        showError('Vänligen fyll i alla obligatoriska passagerarfält.');
        updateTotal();
        return;
      }
      var items = collect();
      if (!items.length){
        showError('Minst en vuxen krävs.');
        return;
      }

      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Skapar bokning...';

      try {
        var bookingRef = await createBooking(items);
        var baseProps = buildBaseProps(items, bookingRef);

        // En (1) produkt av varianten per vuxen – priset 2 495 kr avser hela tur- och returresan.
        var lineProps = Object.assign({}, baseProps, { 'KLASS': 'W', 'Route': 'Visby → Tallinn (tur och retur)' });

        var cartItems = [
          { id: Number(VARIANT_ID), quantity: items.length, properties: lineProps }
        ];

        addBtn.textContent = 'Lägger till i varukorg...';
        var res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items: cartItems }),
          credentials:'same-origin'
        });
        if (!res.ok){
          var t = await res.text().catch(function(){ return ''; });
          throw new Error(t || 'Kunde inte lägga till i varukorg.');
        }
        window.location.href = '/cart';
      } catch(err){
        console.error(err);
        addBtn.disabled = false;
        addBtn.textContent = originalText;
        showSupportBtn(true);
        showErrorHtml('Någonting gick fel med din bokning. Vänligen kontakta support på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> och ange: <code style="background:#f4f4f4;padding:2px 6px;border-radius:4px;font-size:.95em;">' + (err && err.message ? String(err.message).slice(0, 300) : 'okänt fel') + '</code>.');
      }
    }

    // ---- Init & events ----
    renderTripMini();
    render();

    adultsInput.addEventListener('input', render);
    adultsInput.addEventListener('change', render);
    if (adultsMinusBtn) adultsMinusBtn.addEventListener('click', function(){ stepAdults(-1); });
    if (adultsPlusBtn)  adultsPlusBtn.addEventListener('click', function(){ stepAdults(1); });
    list.addEventListener('input', updateTotal);
    list.addEventListener('change', updateTotal);
    if (addBtn) addBtn.addEventListener('click', addToCart);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot, { once:true }); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
